var win = window;

export var raf = win.requestAnimationFrame
  || win.webkitRequestAnimationFrame
  || win.mozRequestAnimationFrame
  || win.msRequestAnimationFrame
  || function(cb) { return setTimeout(cb, 16); };



//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/raf.js
// module id = 15
// module chunks = 0